/** @module qt.router user相关
 *  @description 用户相关路由
 */
import { invokeSchema } from '../base';

/**
 * 跳转用户资料页
 */
export function jumpToUserProfile(): Promise<unknown> {
  return invokeSchema('qingtingfm://app.qingting.fm/user/profile');
}

/**
 * 跳转用户余额
 */
export function jumpToUserBalance(): Promise<unknown> {
  return invokeSchema('qingtingfm://app.qingting.fm/nativepage/mybalance');
}

/**
 * 跳转用户收藏
 */
export function jumpToUserCollection(): Promise<unknown> {
  return invokeSchema('qingtingfm://app.qingting.fm/nativepage/mycollection');
}

/**
 * 跳转用户消息中心
 */
export function jumpToUserMessage(): Promise<unknown> {
  return invokeSchema('qingtingfm://app.qingting.fm/nativepage/messagecenter');
}

/**
 * 跳转用户账号绑定
 */
export function jumpToUserAccountBind(): Promise<unknown> {
  return invokeSchema('qingtingfm://app.qingting.fm/account/binding');
}

/**
 * 跳转客服
 */
export function jumpToCustomService(): Promise<unknown> {
  return invokeSchema('qingtingfm://app.qingting.fm/tools/customservice');
}

/**
 * 跳转用户反馈页
 */
export function jumpToFeedback(): Promise<unknown> {
  return invokeSchema('qingtingfm://app.qingting.fm/tools/feedback');
}

/**
 * 跳转用户信息收集页
 */
export function jumpToPreferenceCollect(): Promise<unknown> {
  return invokeSchema('qingtingfm://app.qingting.fm/userprefercollectpage');
}

/** @ignore */
export const user = {
  jumpToUserInfo: jumpToUserProfile,
  jumpToUserBalance,
  jumpToUserCollection,
  jumpToUserMessage,
  jumpToUserAccountBind,
  jumpToCustomService,
  jumpToFeedback,
  jumpToPreferenceCollect,
};
